import HighlightedSearch from './HighlightedSearch';

export default HighlightedSearch;
